<template>
  <div class="">
    <div v-if="!isHorizontal">{{ field.name }}</div>
    <flat-pickr
      :id="uniqueId"
      v-model="date"
      :config="datePickerConfig"
      :disabled="isFieldDisabled"
      class="timeNoBackground w-100"
      @input="onChange"
    />
    <div class="d-flex flex-column">
      <span class="textHint" v-if="hint">{{ hint }}</span>
      <span class="text-error" v-if="error">{{ error }}</span>
    </div>
  </div>
</template>
<script>
import {ref, onMounted, computed, watch} from "@vue/composition-api";
import flatPickr from "vue-flatpickr-component";
export default {
  components: {
    flatPickr
  },
  props: {
    field: {
      type: Object,
      default: () => ({}),
    },
    isFormDisabled: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    isHorizontal: {
      type: Boolean,
      default: true
    }
  },
  setup(props, { emit }) {
    const uniqueId = Date.now().toString(36) + Math.random().toString(36).slice(2);
    const isFieldDisabled = ref(false);
    const date = ref("");
    const hint = ref("");
    const error = ref(null);
    const defaultFormat = "d/m/Y"
    const format = props?.field?.options?.fieldTypeCfg?.data[0]?.format?.value || defaultFormat
    const datePickerConfig = {
      dateFormat: "d/m/Y",
      allowInput: true,
      locale: {
        firstDayOfWeek: 1,
      },
    };

    watch(
      () => props.errors,
      (newValue, oldValue) => {
        error.value = props.errors[props.field.originalName] || null;
      },
      { immediate: true }
    );

    watch(
      () => props.isFormDisabled,
      (newValue, oldValue) => {
        isFieldDisabled.value = props.isFormDisabled;
      },
      { immediate: true }
    );

    onMounted(async () => {
      hint.value = props?.field?.options?.fieldTypeCfg?.data[0]?.hint;
      isFieldDisabled.value = props.isFormDisabled

      const d = new Date();
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      const showEmpty = props?.field?.options?.fieldTypeCfg?.data[0]?.showEmpty
      date.value = showEmpty ? '' : normalizeDate(`${day}/${month}/${year}`, format)
    });

    function onChange() {
      emit("updateData", props.field, date.value);
    }

    function normalizeDate(input, format) {
      if (!input) return "";
      const pad2 = n => String(n).padStart(2, "0");
      let day, month, year;
      // format "2025-11-12"
      let iso = input.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (iso) {
        year = parseInt(iso[1], 10);
        month = parseInt(iso[2], 10);
        day = parseInt(iso[3], 10);
      } else {
        // formats: "20/12/25", "20-12-2025"
        let m = input.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{2}|\d{4})$/);
        if (!m) return "";

        day = parseInt(m[1], 10);
        month = parseInt(m[2], 10);
        year = parseInt(m[3], 10);

        if (m[3].length === 2) {
          year = 2000 + year;
        }
      }

      if (!(day >= 1 && day <= 31 && month >= 1 && month <= 12)) return "";

      const tokens = {
        d: pad2(day),
        m: pad2(month),
        y: String(year).slice(-2),
        Y: String(year)
      };

      return format.replace(/d|m|y|Y/g, t => tokens[t]);
    }

    return {
      uniqueId,
      isFieldDisabled,
      datePickerConfig,
      date,
      hint,
      error,
      onChange,
    }
  }
}
</script>
<style scoped lang="scss">
.text-error {
  color: #ec0303;
}
.timeNoBackground {
  border-radius: 0.3em;
  background-color: transparent;
  margin: 0;
  border-radius: 0.3em;
  border: 1px solid #cecece;
  padding: 0.75em;
  margin: 0;
  background-color: #fff;
}
.dark-layout {
  .timeNoBackground {
    background-color: var(--second-dark) !important;
    color: #fff;
  }
}
</style>